import { createContext } from 'react';

const LoaderContext = createContext({
    loader: false,
    setLoader: () => {},
});

export default LoaderContext;
